class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.selectedVariantId = null;
    this.cartToast = document.getElementById("cart-toast");
  }

  connectedCallback() {
    this.optionButtons = this.querySelectorAll(".product-card__option-btn");
    this.addToCartBtn = this.querySelector(".product-card__add-to-cart-btn");
    this.newsletterBtn = this.querySelector(".product-card__newsletter-btn");
    this.track = this.querySelector(".product-card__options-track");
    this.prevBtn = this.querySelector(".product-card__carousel-btn--prev");
    this.nextBtn = this.querySelector(".product-card__carousel-btn--next");

    this.optionButtons.forEach((button) => {
      button.addEventListener("click", this.onOptionSelect.bind(this));
    });

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener("click", this.onAddToCart.bind(this));
    }

    if (this.newsletterBtn) {
      this.newsletterBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const productTitle = this.getAttribute("data-product-title");
        document.dispatchEvent(
          new CustomEvent("waitlist:open", { detail: { productTitle } }),
        );
      });
    }

    if (this.track && this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener("click", () => this.scrollTrack(-1));
      this.nextBtn.addEventListener("click", () => this.scrollTrack(1));
      this.track.addEventListener(
        "scroll",
        this.updateCarouselButtons.bind(this),
      );

      // Update buttons when the track becomes visible (display: none -> flex)
      if (window.ResizeObserver) {
        const observer = new ResizeObserver(() => this.updateCarouselButtons());
        observer.observe(this.track);
      }

      // Fallback update on hover just to be safe
      this.addEventListener("mouseenter", () => {
        // Small timeout ensures CSS layout has calculated the new width after hover
        setTimeout(() => this.updateCarouselButtons(), 10);
      });

      this.updateCarouselButtons();
    }
  }

  scrollTrack(direction) {
    const scrollAmount = 100; // Adjust scroll distance
    this.track.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
    console.log("next clicked");
  }

  updateCarouselButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;

    this.prevBtn.disabled = scrollLeft <= 0;
    // Add a small buffer of 1px to account for fractional pixel scrolling
    this.nextBtn.disabled = Math.ceil(scrollLeft + clientWidth) >= scrollWidth;
  }

  onOptionSelect(event) {
    const button = event.currentTarget;
    this.selectedVariantId = button.getAttribute("data-variant-id");
    const isAvailable = button.getAttribute("data-available") === "true";

    // Visual selection feedback
    this.optionButtons.forEach((btn) => btn.classList.remove("is-active"));
    button.classList.add("is-active");

    // Toggle Add to Cart / Newsletter buttons
    if (isAvailable) {
      if (this.addToCartBtn) this.addToCartBtn.style.display = "flex";
      if (this.newsletterBtn) this.newsletterBtn.style.display = "none";
    } else {
      if (this.addToCartBtn) this.addToCartBtn.style.display = "none";
      if (this.newsletterBtn) this.newsletterBtn.style.display = "flex";
    }
  }

  async onAddToCart(event) {
    const button = event.currentTarget;
    const variantId =
      this.selectedVariantId || button.getAttribute("data-variant-id");

    if (button.classList.contains("loading") || !variantId) return;

    this.setLoading(button, true);

    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: "cart-drawer,mejimeji-header",
    };

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || "Failed to add to cart");
      }

      // Update cart drawer using existing global functions
      if (window.updateCartDrawer) {
        await window.updateCartDrawer();
      }

      // if (window.openCart) {
      //   window.openCart();
      // }

      if (this.cartToast && typeof this.cartToast.show === "function") {
        this.cartToast.show("Added to cart", this.stickyBar);
      } else {
        console.log("Added to cart:", data);
      }

      // If cart-drawer.js updateCartCount is available, we can use it with returned sections
      if (
        window.updateCartCount &&
        data.sections &&
        data.sections["mejimeji-header"]
      ) {
        window.updateCartCount(data.sections["mejimeji-header"]);
      }
    } catch (error) {
      console.error("Product Card Error:", error);
    } finally {
      this.setLoading(button, false);
    }
  }

  setLoading(button, isLoading) {
    if (isLoading) {
      button.classList.add("loading");
      button.disabled = true;
    } else {
      button.classList.remove("loading");
      button.disabled = false;
    }
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
